import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import * as Ant from "antd";
import { IncidentReportModalContent } from "./IncidentReportModal.content";
export const IncidentReportModal = memo((props) => {
    return (_jsx(Ant.Modal, { title: "Note de disfonctionnement", visible: props.isVisible, onCancel: props.closeModal, footer: null, bodyStyle: { padding: 0 }, children: _jsx(IncidentReportModalContent, { clientRequestId: props.clientRequestId }) }));
});
